import { Button, Modal } from 'ui'

import style from './CreateModalConfirm.module.scss'

interface IModalConfirm {
  isActive: boolean
  onConfirm(): void
  onCancel(): void
}

// модальное окно для завершения регистрации
export const CreateModalConfirm = () => {
  return ({ isActive, onConfirm, onCancel }: IModalConfirm) => {
    return (
      <Modal open={isActive}>
        <div className={style.modal}>
          <span className={style.title}>
            Вы действительно хотите закрыть эту страницу? регистрация будет
            отменена
          </span>
          <div className={style.btnWrapper}>
            <Button
              onClick={onCancel}
              variant='contained'
              color='primary'
              className={style.closeBtn}
              data-testid='create-modal-cancel'
            >
              {'Отмена'}
            </Button>
            <Button
              onClick={onConfirm}
              color='primary'
              className={style.logoutBtn}
              data-testid='create-modal-confirm'
            >
              {'Да'}
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}
